import { render, staticRenderFns } from "./BattleInProgress.vue?vue&type=template&id=45b97b8f&"
import script from "./BattleInProgress.vue?vue&type=script&lang=js&"
export * from "./BattleInProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports